<template>
   <!-- Page Content -->
        <div id='page-wrapper'>
          <vue-element-loading size='64' is-full-screen :active='isLoadingData' text='جارى تحميل البيانات' spinner='bar-fade-scale' color='#A4A4A4'/>
            <div class='container-fluid'>
                <div class='row'>
                    <div class='col-lg-12'>
                        <h1 class='page-header'>عمليات التصنيع</h1>
                    </div>
                    <!-- /.col-lg-12 -->
                </div>
                <!-- /.row -->
                <div class='row'>
                    <div class='col-lg-12'>
                        <div class='panel panel-default'>
                            <div class='panel-heading'>
                              هنا يتم عرض جميع عمليات التصنيع
                                <div class='pull-left' style='padding=0px'>
                                    <button @click='showForm(0)' type='button' class='btn btn-outline btn-primary btn-sm ' style='padding:3px;width: 80px' data-toggle='modal' data-target='#myModal'>
                                      <b>  إضافة جديد </b>
                                    </button>
                                </div>
                              </div>
                            <!-- /.panel-heading -->
                            <div class='panel-body'>
                              <div class='alert alert-danger alert-dismissable' v-if='mainValidationErrors'>
                                <ul v-if='mainValidationErrors'>
                                    <li v-for='err in mainValidationErrors'  v-bind:key='err.key' v-bind:value='err.key'>{{ err }}</li>
                                </ul>
                              </div>
                              <div class='col-lg-12' style="margin:10px 0px;padding:0px">
                                <div class='col-lg-3 col-md-3 col-sm-3'>
                                      <label>الفرع</label>
                                      <select class="form-control"  v-model="branch_id">
                                        <option v-for="item in branches" v-bind:key="item.id" v-bind:value="item.id">
                                          {{ item.name }}
                                        </option>
                                      </select>
                                </div>
                                <div class='col-lg-3 col-md-3 col-sm-3'>
                                      <label>المنتج</label>
                                      <select class="form-control"  v-model="product_id">
                                        <option v-for="contractItem in contractItems" v-bind:key="contractItem.id" v-bind:value="contractItem.id">
                                          {{ contractItem.item }}
                                        </option>
                                      </select>
                                </div>
                                <div class='col-lg-2 col-md-2 col-sm-3'>
                                  <tbDate  :mytitle='fromTitle' v-model= 'date_from' ></tbDate>
                                </div>
                                <div class='col-lg-2 col-md-2 col-sm-3'>
                                  <tbDate  :mytitle='toTitle' v-model= 'date_to' ></tbDate>
                                </div>
                                    <div style="padding-top:25px" class='col-lg-2 col-md-2 col-sm-6'>
                                        <button @click='GetData()' type='button' class='btn btn-outline btn-primary btn-md btn-block ' style='padding:3px;width: 60px'>
                                          <b> عرض </b>
                                        </button>
                                    </div>
                              </div>
                                <table width='100%' class='table table-striped table-bordered table-hover' id='dataTables-example'>
                                    <thead>
                                      <tr>

                                          <th style='text-align: center'>المنتج</th>
                                          <th style='text-align: center'>الفنى</th>
                                          <th style='text-align: center'>التاريخ</th>
                                          <th style='text-align: center'>الكمية</th>
                                          <th style='text-align: center'>الاجراء</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                        <tr class='odd gradeX' v-for='record in records' :key='record.id'>

                                          <td align='center'>{{record.product_name}}</td>
                                          <td align='center'>{{record.user_name}}</td>
                                          <td align='center'>{{record.date}}</td>
                                          <td align='center'>{{record.quantity}}</td>
                                          <td align='center'>
                                              <vue-element-loading size='32' :active='isLoadingDelete' spinner='bar-fade-scale' color='#A4A4A4'/>
                                              <button @click='deleteData(record.id)' type='button' class='btn btn-outline btn-danger btn-xs'>حذف</button>
                                              <button @click='showForm(record)' type='button' class='btn btn-outline btn-info btn-xs' data-toggle='modal' data-target='#myModal'>عرض</button>
                                              <button @click='showSnForm(record.id)' type='button' class='btn btn-outline btn-info btn-xs' data-toggle='modal' data-target='#SnModal'>طباعة ارقام مسلسلة</button>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                                <!-- /.table-responsive -->
                            </div>
                            <!-- /.panel-body -->
                        </div>
                        <!-- /.panel -->
                    </div>
                    <!-- /.col-lg-12 -->
                </div>
             </div>
             <!-- Modal -->
             <div class='modal fade' id='myModal' tabindex='-1' role='dialog'  aria-labelledby='myModalLabel' aria-hidden='true'>
                 <div class='modal-dialog  modal-lg'>
                     <div class='modal-content'>
                         <div class='modal-header'>
                             <button type='button' class='close' data-dismiss='modal' aria-hidden='true'>&times;</button>
                             <h4 class='modal-title' id='myModalLabel'>{{title}}</h4>
                         </div>
                         <form role='form'>
                         <div class='modal-body'>
                           <div class='alert alert-danger alert-dismissable' v-if='errorShow'>
                             <ul v-if='validationErrors'>
                                 <li v-for='err in validationErrors'  v-bind:key='err.key' v-bind:value='err.key'>{{ err }}</li>
                             </ul>
                           </div>
                           <div class='alert alert-success alert-dismissable' v-if='successShow'>
                              {{success}}
                           </div>
                           <fieldset>
                                 <div class='form-group col-lg-4 col-md-4 col-sm-6'>
                                     <label>الفرع:</label>
                                     <select @change='changeBranche()' class="form-control" style="padding: 0px" v-model="record.branche_id">
                                       <option v-for="branch in branches" v-bind:key="branch.id" v-bind:value="branch.id">
                                         {{ branch.name }}
                                       </option>
                                     </select>
                                 </div>
                                 <div class='form-group col-lg-4 col-md-4 col-sm-6'>
                                     <label>المخزن:</label>
                                     <select class="form-control" style="padding: 0px" v-model="record.store_id">
                                       <option v-for="store in stores" v-bind:key="store.id" v-bind:value="store.id">
                                         {{ store.name }}
                                       </option>
                                     </select>
                                 </div>
                                 <div class='form-group col-lg-4 col-md-4 col-sm-6'>
                                     <label>المنتج:</label>
                                     <select class="form-control" style="padding: 0px" v-model="record.product_id">
                                       <option v-for="contractItem in contractItems" v-bind:key="contractItem.id" v-bind:value="contractItem.id">
                                         {{ contractItem.item }}
                                       </option>
                                     </select>
                                 </div>
                                 <div class='form-group col-lg-4 col-md-4 col-sm-6'>
                                     <label>الفنى:</label>
                                     <select class="form-control" style="padding: 0px" v-model="record.user_id">
                                       <option v-for="technical in technicals" v-bind:key="technical.id" v-bind:value="technical.id">
                                         {{ technical.name }}
                                       </option>
                                     </select>
                                 </div>
                                 <div class='form-group col-lg-4 col-md-4 col-sm-6'>
                                     <tbDate :mytitle='dateTitle' v-model= 'record.date' ></tbDate>
                                 </div>
                                 <div class='form-group col-lg-4 col-md-4 col-sm-6'>
                                     <label>الكمية:</label>
                                     <input v-model='record.quantity' class='form-control' name='quantity' type='text'>
                                 </div>
                               </fieldset>
                               <table width='100%' class='table table-striped table-bordered table-hover' id='dataTables-example'>
                                   <thead>
                                     <tr>

                                         <th style='text-align: center'>م</th>
                                         <th style='text-align: center'>الصنف</th>
                                         <th style='text-align: center'>العدد</th>
                                         <th style='text-align: center'>الاجمالى</th>
                                     </tr>
                                   </thead>
                                   <tbody>
                                       <tr class='odd gradeX' v-for='(record,index) in components' :key='record.id'>

                                         <td align='center'>{{index+1}}</td>
                                         <td align='center'>{{record.item}}</td>
                                         <td align='center'>{{record.quantity}}</td>
                                         <td align='center'>{{record.total}}</td>
                                       </tr>
                                   </tbody>
                               </table>
                           </div>
                           <div class='modal-footer'>
                               <button type='button' class='btn btn-default' data-dismiss='modal'>خروج</button>
                               <vue-element-loading size='32' :active='isLoadingSave' spinner='bar-fade-scale' color='#A4A4A4'/>
                               <button v-show="parseInt(record.id) === 0" @click='saveData' type='button' class='btn btn-primary'>حفظ</button>
                           </div>
                         </form>
                     </div>
                     <!-- /.modal-content -->
                 </div>
                 <!-- /.modal-dialog -->
             </div>
             <!-- /.modal -->
             <!-- Sn_modal -->
             <div class='modal fade' id='SnModal' tabindex='-1' role='dialog'  aria-labelledby='myModalLabel' aria-hidden='true'>
                 <div class='modal-dialog  modal-sm'>
                     <div class='modal-content'>
                         <div class='modal-header'>
                             <button type='button' class='close' data-dismiss='modal' aria-hidden='true'>&times;</button>
                             <h4 class='modal-title' id='myModalLabel'>طباعة الأرقام المسلسلة</h4>
                         </div>
                         <form role='form'>
                         <div class='modal-body'>
                           <div class='alert alert-danger alert-dismissable' v-if='errorShow'>
                             <ul v-if='validationErrors'>
                                 <li v-for='err in validationErrors'  v-bind:key='err.key' v-bind:value='err.key'>{{ err }}</li>
                             </ul>
                           </div>
                           <div class='alert alert-success alert-dismissable' v-if='successShow'>
                              {{success}}
                           </div>
                           <fieldset>
                             <div id="contentToPrint">
                                </div>

                               </fieldset>
                           </div>
                           <div class='modal-footer'>
                               <button type='button' class='btn btn-default' data-dismiss='modal'>خروج</button>
                               <vue-element-loading size='32' :active='isLoadingSave' spinner='bar-fade-scale' color='#A4A4A4'/>
                               <button v-simple-print="'contentToPrint'"  type='button' class='btn btn-primary'>طباعة</button>
                           </div>
                         </form>
                     </div>
                     <!-- /.modal-content -->
                 </div>
                 <!-- /.modal-dialog -->
             </div>
             <!-- /.Sn_modal -->

             <!-- /.container-fluid -->
        </div>
</template>
<script>
import axios from 'axios'
import tbDate from '@/components/myComponents/tbDate'
export default {
  components: {
    tbDate
  },
  name: 'manufacturing_master',
  data () {
    return {
      fromTitle: 'من',
      toTitle: 'إلى',
      date_from: '',
      date_to: '',
      dateTitle: 'التاريخ',
      validationErrors: '',
      mainValidationErrors: '',
      records: {},
      record: {},
      branches: {},
      stores: {},
      items: {},
      components: {},
      serialNm: {},
      technicals: {},
      product_id: '',
      branch_id: '',
      errorShow: false,
      successShow: false,
      isLoadingData: false,
      isLoadingSave: false,
      isLoadingDelete: false,
      title: ''
    }
  },
  created () {
    this.branches = JSON.parse(localStorage.getItem('Branches'))
    this.items = JSON.parse(localStorage.getItem('Items'))
    this.branch_id = localStorage.getItem('BrancheID')
    var today = new Date()
    var dd = String(today.getDate()).padStart(2, '0')
    var mm = String(today.getMonth() + 1).padStart(2, '0')
    var yyyy = today.getFullYear()
    today = dd + '-' + mm + '-' + yyyy
    this.date_from = today
    this.date_to = today
  },
  computed: {
    contractItems () {
      return this.items.filter(item => item.is_contract === 1)
    }
  },
  methods: {
    changeBranche () {
      let i = this.branches.findIndex(x => x.id === parseInt(this.record.branche_id))
      if (i > -1) {
        this.stores = this.branches[i].stores
        this.technicals = this.branches[i].technicals
      }
    },
    GetData () {
      this.mainValidationErrors = ''
      this.isLoadingData = true
      axios.post(this.$apiURL + 'getManufacturingMaster', {
        token: localStorage.getItem('token'),
        product_id: this.product_id,
        branch_id: this.branch_id,
        date_from: this.date_from,
        date_to: this.date_to
      })
        .then(({ data }) => {
          this.records = data
          this.isLoadingData = false
        })
        .catch(err => {
          if (err.response.data.errors === 'Forbidden') {
            this.$router.push('accessdeny')
          }
          if (err.response.data.message === 'Unauthenticated.') {
            this.$router.push('login')
          }
          this.mainValidationErrors = err.response.data.errors
          this.isLoadingData = false
        })
    },
    showForm (recID) {
      this.errorShow = false
      this.successShow = false
      this.error = ''
      if (recID === 0) {
        this.title = 'إضافة سجل جديد'
        this.components = ''
        this.record = {
          'id': 0,
          'branche_id': '',
          'store_id': '',
          'product_id': '',
          'user_id': '',
          'date': '',
          'branch_name': '',
          'product_name': '',
          'quantity': '',
          'user_name': '',
          'store_name': ''
        }
        var today = new Date()
        var dd = String(today.getDate()).padStart(2, '0')
        var mm = String(today.getMonth() + 1).padStart(2, '0')
        var yyyy = today.getFullYear()
        today = yyyy + '-' + mm + '-' + dd
        this.record.date = today
      } else {
        this.title = 'تعديل بيانات سجل'
        this.record = recID
        this.get_components(recID.id)
        this.changeBranche()
      }
    },
    showSnForm (id) {
      this.mainValidationErrors = ''
      this.isLoadingData = true
      axios.post(this.$apiURL + 'getSerialNm', {
        token: localStorage.getItem('token'),
        id: id
      })
        .then(({ data }) => {
          this.serialNm = data
          this.isLoadingData = false
        })
        .catch(err => {
          if (err.response.data.errors === 'Forbidden') {
            this.$router.push('accessdeny')
          }
          if (err.response.data.message === 'Unauthenticated.') {
            this.$router.push('login')
          }
          this.mainValidationErrors = err.response.data.errors
          this.isLoadingData = false
        })
    },
    get_components (id) {
      this.mainValidationErrors = ''
      this.isLoadingData = true
      axios.post(this.$apiURL + 'getcomponents', {
        token: localStorage.getItem('token'),
        id: id
      })
        .then(({ data }) => {
          this.components = data
          this.isLoadingData = false
        })
        .catch(err => {
          if (err.response.data.errors === 'Forbidden') {
            this.$router.push('accessdeny')
          }
          if (err.response.data.message === 'Unauthenticated.') {
            this.$router.push('login')
          }
          this.mainValidationErrors = err.response.data.errors
          this.isLoadingData = false
        })
    },
    saveData () {
      this.isLoadingSave = true
      axios.post(this.$apiURL + 'saveManufacturingMaster', {
        token: localStorage.getItem('token'),
        id: this.record.id,
        branche_id: this.record.branche_id,
        store_id: this.record.store_id,
        product_id: this.record.product_id,
        user_id: this.record.user_id,
        date: this.record.date,
        quantity: this.record.quantity
      })
        .then(res => {
          this.get_components(res.data.id)
          this.isLoadingSave = false
          // this.records.push(res.data)
          this.success = 'تم الحفظ بنجاح'
          this.successShow = true
          this.errorShow = false
        })
        .catch(err => {
          if (err.response.data.message === 'Unauthenticated.') {
            this.$router.push('login')
          }
          if (err.response.data.errors === 'Forbidden') {
            this.$router.push('accessdeny')
          }
          this.validationErrors = err.response.data.errors
          this.errorShow = true
          this.isLoadingSave = false
        })
    },
    deleteData (recID) {
      this.isLoadingDelete = true
      axios.post(this.$apiURL + 'deleteManufacturingMaster', {
        token: localStorage.getItem('token'),
        id: recID
      })
        .then(res => {
          let i = this.records.map(record => record.id).indexOf(recID)
          this.records.splice(i, 1)
          this.isLoadingDelete = false
        })
        .catch(err => {
          if (err.response.data.errors === 'Unauthenticated') {
            this.$router.push('login')
          }
          if (err.response.data.errors === 'Forbidden') {
            this.$router.push('accessdeny')
          }
          this.error = err.message
          this.isLoadingDelete = false
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/purchases/Manufacturing.vue